import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=6a40df8c&scoped=true&"
import script from "./FileThumbnail.vue?vue&type=script&lang=js&"
export * from "./FileThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=6a40df8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40df8c",
  null
  
)

export default component.exports